'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter("fixing", function (stringUtils) {
  return function tauxFilter(value, fixedDecimals) {
    if (value == null) {
      return "-";
    }
    var isFixedDecimals = !_.isUndefined(fixedDecimals);
    var format;
    if (isFixedDecimals) {
      var nbDecimals = parseInt(fixedDecimals);
      format = "0,0." + stringUtils.repeatSequence("0", nbDecimals);
    } else {
      format = "0,0.[00]";
    }
    var res = "";

    // todo - a reprendre car on ne transmet plus tout l'index mais juste son id
    if (value.index.type === 'TAUX') {
      res = numeral(value.valeur * 100).format(format) + " %";
    } else {
      res = numeral(value.valeur).format(format);
    }
    if (value.type === 'ESTIME') {
      res += "*";
    }
    return res;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/fixing-filters.js
// module id = 2702
// module chunks = 13